// Versioned, local homepage assets avoid routing large, immutable media through
// the application proxy while keeping cache invalidation explicit.
export const HOME_HERO_IMAGE_URL =
  "/assets/landing/smart-manager-home-hero.v1.2400.webp";

// Intrinsic size of the source; next/image derives the smaller variants from it.
export const HOME_HERO_IMAGE_WIDTH = 2400;
export const HOME_HERO_IMAGE_HEIGHT = 1332;

// Rendered width on desktop: 70vh tall at the source aspect ratio
// (0.7 * 2400 / 1332 = 1.2613), i.e. 126.13vh wide. Only the desktop
// landing shows the collage; phones and tablets never load it.
export const HOME_HERO_IMAGE_SIZES_DESKTOP = "126.13vh";

export const SMART_MANAGER_LOGO_URL =
  "/assets/landing/smart-manager-logo.v1.192.webp";
